import React, { useState } from 'react';
import cn from 'classnames';
import FinalForm from '@/Framework/UI/Organisms/FinalForm';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import validate from './contactFormValidator';
import ContactUsRepository from '@/finsight/infrastructure/repository/ContactUsRepository';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import { getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import { useDIContext } from '@/Framework/DI/DIContext';
import ContactFormFields from '@/finsight/ui/components/staticPages/Company/ContactUs/ContactForm/ContactFormFields';
import { TFinalFormRenderProp } from '@/Framework/UI/Organisms/FinalForm/interfaces';

import logoWings from '@/Framework/assets/logo/logoWings.inline.svg';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import contactFormStyles from './contactForm.scss';

const ContactForm = () => {
  const { container } = useDIContext();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  const renderDetailsForm: TFinalFormRenderProp = ({
    invalid,
    pristine,
  }, { Field }) => {
    return <ContactFormFields FieldComponent={ Field } isInvalid={ invalid } isPristine={ pristine } />;
  };

  const submit = async ({
    email = '',
    name = '',
    feedback,
    recaptcha: token,
  }, formApi) => {
    setIsFetching(true);

    const datetime = new Date().toString();

    try {
      const contactUsRepository = container.get(ContactUsRepository);
      const letter = await contactUsRepository.submitLetter({
        email,
        name,
        feedback,
        token,
        datetime,
      });

      if (letter.statusCode === 200 && letter.original.result === 'error') {
        throw (new Error(letter.original));
      }

      setIsFormSubmitted(true);
      formApi.restart();
    } catch (error) {
      setIsFetching(false);
      AlertManager.error(getErrorMessage(error));
    }
  };

  const reset = () => {
    setIsFetching(false);
    setIsFormSubmitted(false);
  };

  return (
    <div className={ contactFormStyles.contactFormWrapper }>
      <div className={ contactFormStyles.logo }>
        <i dangerouslySetInnerHTML={ { __html: logoWings } } />
      </div>
      <div className={ contactFormStyles.title }>Contact Us</div>
      <div className={ contactFormStyles.subTitle }>Please send us your questions, comments or suggestions.</div>
      <FinalForm
        role="form"
        id="modalForm"
        dataTest="contactUsForm"
        name="contactUsForm"
        className={ cn(spacesStyles.mtxl, contactFormStyles.form) }
        render={ renderDetailsForm }
        onSubmit={ submit }
        validate={ validate }
      />
      { isFetching && <Spinner overlay /> }
      <div className={ cn(contactFormStyles.successSubmitting, {
        [contactFormStyles.succeedSubmit]: isFormSubmitted,
      }) }
      >
        <div className={ contactFormStyles.logo }>
          <i dangerouslySetInnerHTML={ { __html: logoWings } } />
        </div>
        <div className={ contactFormStyles.title }>Contact Us</div>
        <div className={ contactFormStyles.successSubmittingTitle }>Thank you!</div>
        <div className={ contactFormStyles.successSubmittingSubtitle }>Your feedback has been submitted.</div>
        <a
          data-test="addNewSubmission"
          className={ contactFormStyles.backToForm }
          onClick={ reset }
        >
          Add new submission
        </a>
      </div>
    </div>
  );
};

export default ContactForm;
